module.exports = __webpack_public_path__ + "img/qrcode.73dcc84d.png";